import { Global } from "@emotion/react";

// The AngularJS page footer is `position: fixed` at z-index 999999 (see shared/theme.ts), above
// any React drawer or modal that has to sit below the AngularJS Bootstrap modals (z-index 1040+).
// Render this while such an overlay is open so the footer doesn't cover its bottom; it is removed
// again when this unmounts.
const hideLegacyFooter = { "#page-wrapper .footer": { display: "none" } };

export default function HideLegacyFooter() {
  return <Global styles={hideLegacyFooter} />;
}
